<template>
  <div class="p-text-center">
    <span class="material-icons p-mt-5" style="font-size: 2.5rem"> lock </span>
    <p class="p-mt-3">
      Desculpe, você não está autorizado <br />
      a acessar esta página.
    </p>
  </div>
</template>

<script>
export default {
  name: 'AppPermissionAlert',
};
</script>

<style scoped>
p {
  font-size: 1.5rem;
}
</style>
